module.exports = __webpack_public_path__ + "img/movers_thumbnail.9336694b.jpg";